import apiClient from '@/services/api/clients/api-client.js'
import { API_URL } from '@/config'

const basePath = `${API_URL}/messaging/`

const build = function(tenantId, channelId) {
  const path = `${basePath}${tenantId}/channel/${channelId}/message`
  return apiClient.build(path)
}

export default {
  build
}
